'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
  unix时间戳 + 随机数据 生成不重复的 id
*/
var randomStr = function randomStr() {
  return _lodash2.default.now() + 'z' + _lodash2.default.random(0, 1000000);
};

/**
  随机颜色
*/
var customColor = function customColor() {
  return '#' + Math.floor(Math.random() * (256 * 256 * 256 - 1)).toString(16);
};

/**
  时间字符串变量，将指定字符串中的"变量字符"替换成对应的字符串(传递 moment 支持的参数实现)

  参数为四部分：[基准时间字符串，模版字符串，时间偏移，起始时间]

    模版字符串[必选]    : string, 模版字符串，根据 moment 支持的格式设置，如将 YYYY 替换为当前年
    基准时间字符串[可选] : string, 表示从哪个时间开始计算，格式必须为: YYYY-MM-DD HH:mm:ss
    时间偏移[可选]     :  array, [‘add/subtract’, NUM, 单位]，以当前时间为基准，增加或减少指定单位的时间
    起始时间[可选]    :  array, ['startOf/endOf', 'year/month/week/day/hour/minute/second']

    第二、三、四 部分为空或未设置，表示当前时间

    YYYY : 年
    MM   : 月
    DD   : 日
    HH   : 时
    mm   : 分
    ss   : 秒

  参数格式举例:
    模版: ['模版字符串', '基准时间字符串', ['add/subtract', NUM, 'years/months/weeks/days/hours/minutes/seconds/milliseconds'], ['startOf/endOf', 'year/month/week/day/hour/minute/second']]
    今天当前时间: ['YYYY-MM-DD HH:mm:ss']
    今天结束时间: ['YYYY-MM-DD HH:mm:ss', '', [], ['endOf', 'day']]
    明天开始时间: ['YYYY-MM-DD HH:mm:ss', '', ['add', 1, 'days'], ['startOf', 'day']]
    昨天开始时间: ['YYYY-MM-DD HH:mm:ss', '', ['subtract', 1, 'days'], ['startOf', 'day']]
    2018-01-01 00:00:00 的昨天: ['YYYY-MM-DD', '2018-01-01 00:00:00', ['subtract', 1, 'days'], ['startOf', 'day']]
*/

var dateTemplate = function dateTemplate(textArr) {
  /**
    如果不是列表则直接返回，目的是处理字符串的情况
  */
  if (!_lodash2.default.isArray(textArr)) {
    return textArr;
  }

  var template = _lodash2.default.get(textArr, 0, null);
  var baseTime = _lodash2.default.get(textArr, 1, '');
  var offset = _lodash2.default.get(textArr, 2, []);
  var startEnd = _lodash2.default.get(textArr, 3, []);
  var now = (0, _moment2.default)();

  if (template) {
    /**
      计算基准时间，默认为当前时间
    */
    if (_lodash2.default.get(baseTime, 'length') > 0) {
      now = (0, _moment2.default)(baseTime, 'YYYY-MM-DD HH:mm:ss');
    }
    /**
      处理时间偏移，只支持 加 或减
    */
    var operate = _lodash2.default.get(offset, 0, null);
    if (operate === 'add') {
      var num = _lodash2.default.get(offset, 1, null);
      var unit = _lodash2.default.get(offset, 2, null);
      if (num) {
        now = now.add(num, unit);
      }
    } else if (operate === 'subtract') {
      var _num = _lodash2.default.get(offset, 1, null);
      var _unit = _lodash2.default.get(offset, 2, null);
      if (_num) {
        now = now.subtract(_num, _unit);
      }
    }
    /**
      处理起始时间
    */
    var displayAt = _lodash2.default.get(startEnd, 0, null);
    if (displayAt === 'startOf') {
      var _unit2 = _lodash2.default.get(startEnd, 1, null);
      if (_unit2) {
        now = now.startOf(_unit2);
      }
    } else if (displayAt === 'endOf') {
      var _unit3 = _lodash2.default.get(startEnd, 1, null);
      if (_unit3) {
        now = now.endOf(_unit3);
      }
    }

    /**
      处理显示样式
    */
    return now.format(template);
  }

  return '';
};

exports.default = {
  randomStr: randomStr,
  customColor: customColor,
  dateTemplate: dateTemplate
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-js-tools/build/libs/string.js
// module id = 1491
// module chunks = 0